<template>
    <v-container class="form-container" v-if="mode!=''">
        <g-form controller="workflow" :title="controller.currentSystemModule.name+' '+mode" :mode="mode" />
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                controller: this.get_controller('workflow'),
            }
        },
        computed: {
            mode() {
                if (this.$route.params.id == 0) {
                    return "create"
                } else {
                    return "edit"
                }
            }
        },
        mounted() {
            console.log(this.$route.params);

            console.log(this.mode);
        }
    }
</script>

<style>

</style>